module.exports = __webpack_public_path__ + "assets/img/10.41ee476a.png";